import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { fetchSectorRequest, fetchSectorsRequest, deleteSectorRequest, openEditPage, verifyUserRequest, openEditPageSector, clearSectorErrors, clearSectorSuccess } from "../../store/actions";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

export default function Sectors () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const parameters = useSelector(state => state.Parameters);
  document.title = `${t('sectors')} | ${parameters.appName}`; //meta title

  const {sectors, sectorAdded, errorSector} = useSelector(state => state.Sectors);

  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'lib', type: 'text' },
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  useEffect(() => {
    dispatch(fetchSectorsRequest());
  }, []);

  ErrorHandler(errorSector, clearSectorErrors);

  useEffect(() => {
    if (sectorAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearSectorSuccess());
    }
  }, [sectorAdded]);

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("sectors")}/>
          
          <TableContainer
            columnConfig={columnConfig}
            filterConfig={[]}
            data={sectors}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="newSector"
            prefListName="sector"
            totalKpi={{label: 'numberOfSectors', icon: 'mdi mdi-earth'}}
            isAddButton={true}
            isNewButton={false}
            linkToNew={'/sectors/new'}
            editFunction={openEditPageSector} 
            deleteFunction={deleteSectorRequest}
            defaultSortColumn={'lib'}
            defaultSortDirection={'asc'}
          />
        </Container>
        <ToastContainer />
      </div>

  );
};

